import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

import { FaHome, FaBlog, FaQuestion, FaReply as FaQuestionCircle } from 'react-icons/fa';

const Header = () => (
  <header className="header">
    <div>
        <Link to="/" className="head-link" onClick="reload()" title="Home">
          <FaHome/>
        </Link>
    </div>

    <div>
        <a href="/blog" className="head-link" title="Blog">
          <FaBlog/>
        </a>
        <Link to="/faq" className="head-link" title="FAQ">
            <FaQuestionCircle/>
        </Link>
        <Link to="/about" className="head-link" title="About">
            <FaQuestion/>
        </Link>
    </div>
  </header>
);

export default Header;
